import { JSX, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ReplayIcon from '@mui/icons-material/Replay';
import { Divider, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { useLocation, useNavigate } from 'react-router-dom';
//import Add from "components/dialog/paycodes/Add";
import { PaycodeDialog } from "components/dialog/paycodes/PaycodeDialog";
//import Edit from "components/dialog/paycodes/Edit";
//import Delete from "components/dialog/paycodes/Delete";
import { Paycode } from "repository/timekeeper/@types/PaycodeModel";
import { buildSettingsBasePath, buildSettingsCrudPath, parseSettingsCrudRoute } from 'utils/settingsCrudRouting';

interface ContextMenuProps {
    contextMenu: { mouseX: number; mouseY: number } | null;
    setContextMenu: React.Dispatch<React.SetStateAction<{ mouseX: number; mouseY: number } | null>>;
    selectedRow: Paycode[];
    rows: Paycode[];
    reloading: () => void;
    cleanSelected: () => void;
}

interface Option {
    name: string;
    icon: JSX.Element;
    click: () => void;
    color: string;
    divider: boolean;
    disabled: boolean;
    selected: boolean;
    onlyOne: boolean;
    hidden: boolean;
}

const ContextMenu = ({contextMenu, setContextMenu, selectedRow, rows, reloading, cleanSelected}: ContextMenuProps) => {
    const { t } = useTranslation()
    const location = useLocation();
    const navigate = useNavigate();

    const [localOpen, setLocalOpen] = useState(false)
    const [localMode, setLocalMode] = useState<'add' | 'edit' | 'delete' | 'info'>('add')
    const basePath = buildSettingsBasePath('paycodes')
    const modalRoute = useMemo(() => parseSettingsCrudRoute(location.pathname, 'paycodes'), [location.pathname])
    const routeOpen = modalRoute.action === 'add' || (modalRoute.action === 'update' && modalRoute.id !== null) || (modalRoute.action === 'detail' && modalRoute.id !== null)
    const routeMode: 'add' | 'edit' | 'info' = modalRoute.action === 'add' ? 'add' : modalRoute.action === 'detail' ? 'info' : 'edit'
    const open = routeOpen || localOpen
    const mode = routeOpen ? routeMode : localMode

    const selectedRowFromRoute = useMemo(() => {
        if (modalRoute.id === null) return null
        return rows.find((row) => Number(row.id) === modalRoute.id) || null
    }, [rows, modalRoute.id])
    const selectedRowsForDialog = selectedRowFromRoute ? [selectedRowFromRoute] : selectedRow

    const closeDialog = () => {
        if (routeOpen) {
            navigate(basePath)
        } else {
            setLocalOpen(false)
        }
    }
    //const [openEdit, setOpenEdit] = useState(false)
    //const [openDelete, setOpenDelete] = useState(false)

    const options: Option[] = [
        {
            name: t('settings.paycodes.table.context_menu.add'),
            icon: <AddIcon />,
            click: () => {
                navigate(buildSettingsCrudPath('paycodes', 'add'))
                setContextMenu(null)
            },
            color: '',
            divider: false,
            disabled: false,
            selected: false,
            onlyOne: false,
            hidden: (JSON.parse(localStorage.getItem("permissions") || '[]') as string[]).find(permision => permision === 'timekeeper.CreatePaycode') ? true : false,
        },
        {
            name: t('settings.paycodes.table.context_menu.edit'),
            icon: <EditIcon />,
            click: () => {
                const current = selectedRow[0]
                if (!current?.id) return
                navigate(buildSettingsCrudPath('paycodes', 'update', current.id))
                setContextMenu(null)
            },
            color: '',
            divider: false,
            disabled: selectedRow?.length === 1 ? false : true,
            selected: false,
            onlyOne: true,
            hidden: (JSON.parse(localStorage.getItem("permissions") || '[]') as string[]).find(permision => permision === 'timekeeper.UpdatePaycode') ? true : false,
        },
        {
            name: t('settings.paycodes.table.context_menu.delete'),
            icon: <DeleteIcon color='error'/>,
            click: () => {
                setLocalMode('delete')
                setLocalOpen(true)
                setContextMenu(null)
            },
            color: 'error',
            divider: false,
            disabled: selectedRow.length <= 0,
            selected: true,
            onlyOne: false,
            hidden: (JSON.parse(localStorage.getItem("permissions") || '[]') as string[]).find(permision => permision === 'timekeeper.DeletePaycode') ? true : false,
        },
        {
            name: t('settings.paycodes.table.context_menu.reload'),
            icon: <ReplayIcon />,
            click: () => {
                reloading()
                cleanSelected()
                setContextMenu(null)
            },
            color: '',
            divider: true,
            disabled: false,
            selected: false,
            onlyOne: false,
            hidden: false,
        }
    ]

    return (
        <>
            <Menu
                open={contextMenu ? true : false }
                onClose={() => setContextMenu(null)}
                anchorReference="anchorPosition"
                anchorPosition={contextMenu ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined }
                sx={{boxShadow: 'none'}}
            >
                {options.map((option, index) => (

                    <div key={option.name} hidden={(option.onlyOne && selectedRow?.length !== 1)}>
                        {option.divider && <Divider />}
                        <MenuItem onClick={option.click} disabled={option.disabled} >
                            <ListItemIcon>{option.icon}</ListItemIcon>
                            <ListItemText primary={option.name} slotProps={{ primary: { color: option.color } }} />
                        </MenuItem>
                    </div>
                ))}
            </Menu>
            <PaycodeDialog open={open} mode={mode} onClose={closeDialog} rows={rows} selectedRow={selectedRowsForDialog} reloading={reloading} />
            {/* { openAdd && <Add open={openAdd} setOpen={setOpenAdd} rows={rows} reloading={reloading} /> }
            { openEdit && <Edit open={openEdit} setOpen={setOpenEdit} selectedRow={selectedRow} rows={rows} reloading={reloading} /> }
            { openDelete && <Delete open={openDelete} setOpen={setOpenDelete} selectedRow={selectedRow} reloading={reloading} /> } */}
        </>
    )
}

export { ContextMenu }